import { ProblemAlert } from '@/components/error-surface'
import type { ApiError } from '@/lib/problem-details'

import { tellerErrorRemedy } from './errors'

/**
 * A refusal, with the remedy underneath it.
 *
 * The shared `ProblemAlert` renders what the server said, its code, and the correlation id. This
 * adds the one thing a person standing at a counter needs and the server does not always give: what
 * to do next. The mapping is in `errors.ts` and covers the module's whole surface, validators
 * included — an operator should never be left reading `teller.note_too_long` and guessing at a cap.
 */
export function TellerProblem({ error, className }: { error: ApiError; className?: string }) {
  const remedy = tellerErrorRemedy(error.code)

  return (
    <div className={className}>
      <ProblemAlert error={error} />
      {remedy ? <p className="mt-1.5 text-xs text-body">{remedy}</p> : null}
    </div>
  )
}
